import { render, staticRenderFns } from "./noteTable.vue?vue&type=template&id=31fa6ad0&scoped=true&"
import script from "./noteTable.vue?vue&type=script&lang=js&"
export * from "./noteTable.vue?vue&type=script&lang=js&"
import style0 from "./noteTable.vue?vue&type=style&index=0&id=31fa6ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa6ad0",
  null
  
)

export default component.exports